import { useState } from 'react';
import { toast } from 'react-toastify';
import UseContext from 'hooks/useContext';
import useModal from 'components/modal/useModal';
import {
  getPerimeterErrorMessage,
  isNameError,
  isStalePerimeterError,
} from 'components/perimeter/perimeterErrors';
import { PERIMETERS_CHANGED } from 'components/perimeter/perimeterUsage';

// Behaviour shared by the perimeter modals of the company panel: a close that
// waits for the request in flight, a reload of the block after a write, and
// one policy for the api errors.
const usePerimeterModal = () => {
  const { toggle } = useModal();
  const { language, modalData, setModalDataReturn } = UseContext();
  const [isSaving, setIsSaving] = useState(false);
  // The modal is mounted anew on each opening: what it opened with is enough.
  const [data] = useState(() => modalData || {});

  // Closing while the request is in flight would hide its outcome.
  const close = () => {
    if (isSaving) return;
    toggle();
  };

  const closeAndReload = () => {
    setModalDataReturn({ type: PERIMETERS_CHANGED, idCompany: data.idCompany });
    toggle();
  };

  const succeed = (message) => {
    toast.success(message);
    closeAndReload();
  };

  // A perimeter that changed or vanished closes the modal and reloads the
  // block. Otherwise a name error goes under the field when the modal has
  // one, and anything else is a toast on the open modal.
  const fail = (err, { overrides, onNameError } = {}) => {
    console.error(err);
    const message = getPerimeterErrorMessage(language, err, overrides);
    if (isStalePerimeterError(err)) {
      toast.error(message);
      closeAndReload();
      return;
    }
    setIsSaving(false);
    if (onNameError && isNameError(err)) onNameError(message);
    else toast.error(message);
  };

  return { data, isSaving, setIsSaving, close, succeed, fail };
};

export default usePerimeterModal;
